import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CartProvider } from './routes/CartContext'
import {
  createBrowserRouter,
  RouterProvider,
  redirect
} from "react-router-dom";

import Frame from "./routes/frame";
import Product from "./routes/product";
import Personalize from "./routes/personalize";
import Preview from "./routes/preview";
import Cart from "./routes/cart"
import SuccessPage from './routes/success';
import CartPreview from './routes/cart-preview';
import OrderPage from './routes/order';
import SignUp from './routes/signup';
import Login from './routes/login';
import Account from './routes/account';
import GiftBook from './routes/gift-book';

import { Amplify } from 'aws-amplify';
import awsConfig from './aws-exports';

Amplify.configure(awsConfig);

/* all pages in book builder app */
const router = createBrowserRouter([
  {
    path: "/",
    element: <Frame />,

    children: [
      {
        path: "/",
        loader: () => redirect("https://grieversandfriends.com/"),
      },
      {
        path: "/books/:productId",
        loader: () => {
          const productId = window.location.pathname.split('/')[2];
          return redirect(`https://grieversandfriends.com/books/${productId}`);
        }
      },
      {
        path: "/books/:productId/personalize",
        element: <Personalize title={"Grievers and Friends - Personalize"} />,
      },
      {
        path: "/books/:productId/preview",
        element: <Preview title={"Grievers and Friends - Book Preview"} />,
      },
      {
        path: "/cart",
        element: <Cart title={"Grievers and Friends - Cart"} />
      },
      {
        path: "/books/:productId/preview/:itemId",
        element: <CartPreview title={"Grievers and Friends - Book Preview"} />
      },
      {
        path: "/success",
        element: <SuccessPage title={"Grievers and Friends - Order Confirmation"} />
      },
      {
        path: "/order",
        element: <OrderPage title={"Grievers and Friends - Order Details"} />
      },
      {
        "path": "/signup",
        element: <SignUp title={"Grievers and Friends - Sign Up"} />,
      },
      {
        "path": "/login",
        element: <Login title={"Grievers and Friends - Login"} />,
      },
      {
        "path": "/account",
        element: <Account title={"Grievers and Friends - Account"} />,
      },
      {
        "path": "/gift-book",
        element: <GiftBook title={"Grievers and Friends - Gift a Book"} />,
      },
      {
        path: '*', // Catch-all route for 404
        loader: () => {
          return redirect("https://grieversandfriends.com/");
        }
      },
    ],
  },
  {
    path: '*', // Catch-all route for 404
    loader: () => {
      return redirect("https://grieversandfriends.com/");
    }
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <CartProvider>
        <RouterProvider router={router} />
      </CartProvider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
